export default {
  title: 'Create new activity',
  backButton: 'All activities',
};
